import { Reveal } from "@/components/Reveal";

const FEATURES = [
  {
    n: "01",
    title: "Personal Approach",
    text: "Work directly with the people designing your website.",
  },
  {
    n: "02",
    title: "Built Around Your Brand",
    text: "Every website should feel like your business, not a recycled template.",
  },
  {
    n: "03",
    title: "Designed to Grow",
    text: "Build a digital presence that can evolve alongside your business.",
  },
];

export const WhyNovo = ({ compact = false }) => {
  if (compact) {
    return (
      <section data-testid="why-novo-section" className="border-y border-white/5 bg-[#0d0d0f]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-24 grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <Reveal className="lg:col-span-4">
            <p className="mono text-[11px] tracking-[0.28em] uppercase text-neutral-500 mb-4">Why Novo</p>
            <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-neutral-50">
              Simple. Modern. Personal.
            </h2>
            <p className="text-neutral-400 mt-5 leading-relaxed text-sm">
              We don't believe businesses need complicated websites. They need websites that look great, communicate
              clearly and make people want to do business with them.
            </p>
          </Reveal>
          <div className="lg:col-span-8 grid sm:grid-cols-3 gap-8">
            {FEATURES.map((f, i) => (
              <Reveal key={f.n} delay={i * 0.1}>
                <div data-testid={`why-novo-feature-${f.n}`}>
                  <span className="mono text-xs text-neutral-600 tracking-[0.2em]">{f.n}</span>
                  <h3 className="font-display text-lg font-semibold text-neutral-100 mt-3">{f.title}</h3>
                  <p className="text-sm text-neutral-400 leading-relaxed mt-2">{f.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="about" data-testid="why-novo-section" className="relative py-28 lg:py-40 px-5 sm:px-8 border-t border-white/5">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 lg:gap-24">
        <div>
          <Reveal>
            <p className="mono text-[11px] tracking-[0.28em] uppercase text-neutral-500 mb-5">Why Novo</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-neutral-50">
              Simple. Modern. Personal.
            </h2>
            <p className="text-neutral-400 mt-6 leading-relaxed text-sm sm:text-base max-w-md">
              We don't believe businesses need complicated websites. They need websites that look great, communicate
              clearly and make people want to do business with them.
            </p>
          </Reveal>
        </div>
        <div>
          {FEATURES.map((f, i) => (
            <Reveal key={f.n} delay={i * 0.1}>
              <div data-testid={`why-novo-feature-${f.n}`} className="flex gap-8 border-t border-white/5 py-9 last:border-b">
                <span className="mono text-sm text-neutral-600 tracking-[0.2em] pt-1">{f.n}</span>
                <div>
                  <h3 className="font-display text-xl sm:text-2xl font-semibold text-neutral-100">{f.title}</h3>
                  <p className="text-sm sm:text-base text-neutral-400 leading-relaxed mt-2.5">{f.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
